import type { ReactNode } from 'react';
import type { ImportDecision, PlanEntry } from '../../lib/types';

interface PlanDecisionProps {
  entry: PlanEntry;
  label: string;
  decision: ImportDecision | null;
  disabled: boolean;
  onDecide: (entryId: string, decision: ImportDecision) => void;
}

/** Keeps every review choice tied to its original plan entry. */
export function PlanDecision({ entry, label, decision, disabled, onDecide }: PlanDecisionProps): ReactNode {
  if (entry.action === 'unchanged') return null;
  const creating = entry.action === 'create';

  return (
    <div className="seg imp-decision" role="group" aria-label={`Entscheidung für ${label}`}>
      <button
        type="button"
        className={decision === 'incoming' ? 'on' : undefined}
        aria-pressed={decision === 'incoming'}
        title={creating ? 'Neu anlegen' : 'Dateiwerte übernehmen'}
        disabled={disabled}
        onClick={() => onDecide(entry.entry_id, 'incoming')}
      >
        Übernehmen
      </button>
      <button
        type="button"
        className={decision === 'existing' ? 'on keep' : undefined}
        aria-pressed={decision === 'existing'}
        title={creating ? 'Diesen neuen Eintrag überspringen' : 'Bisherigen Stand behalten'}
        disabled={disabled}
        onClick={() => onDecide(entry.entry_id, 'existing')}
      >
        {creating ? 'Überspringen' : 'Behalten'}
      </button>
    </div>
  );
}
